import axios from 'axios';

const api = axios.create({
  baseURL: 'https://dex-api.qie.systems/',
  withCredentials: false,
});

export default api;
